import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "kentencharacter"
    }}>{`KentenCharacter`}</h1>
    <p>{`Style options for kenten characters.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`NONE`}</strong>{` = 1852796517`}</p>
      <p parentName="blockquote">{`Does not use kenten.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`KENTEN_SESAME_DOT`}</strong>{` = 1248551795`}</p>
      <p parentName="blockquote">{`Uses the kenten sesame dot.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`KENTEN_WHITE_SESAME_DOT`}</strong>{` = 1248551799`}</p>
      <p parentName="blockquote">{`Uses the kenten white sesame dot.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`KENTEN_BLACK_CIRCLE`}</strong>{` = 1248551523`}</p>
      <p parentName="blockquote">{`Uses the kenten black circle.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`KENTEN_WHITE_CIRCLE`}</strong>{` = 1248556899`}</p>
      <p parentName="blockquote">{`Uses the kenten white circle.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`KENTEN_BLACK_TRIANGLE`}</strong>{` = 1248551540`}</p>
      <p parentName="blockquote">{`Uses the kenten black triangle.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`KENTEN_WHITE_TRIANGLE`}</strong>{` = 1248556916`}</p>
      <p parentName="blockquote">{`Uses the kenten white triangle.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`KENTEN_BULLSEYE`}</strong>{` = 1248551525`}</p>
      <p parentName="blockquote">{`Uses the kenten bullseye.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`KENTEN_FISHEYE`}</strong>{` = 1248552549`}</p>
      <p parentName="blockquote">{`Uses the kenten fisheye.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`KENTEN_SMALL_BLACK_CIRCLE`}</strong>{` = 1248555875`}</p>
      <p parentName="blockquote">{`Uses the kenten small black circle.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`KENTEN_SMALL_WHITE_CIRCLE`}</strong>{` = 1248555895`}</p>
      <p parentName="blockquote">{`Uses the kenten small white circle.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CUSTOM`}</strong>{` = 1131639917`}</p>
      <p parentName="blockquote">{`Uses a custom kenten style.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      